/** Date/time formatting for the console. All timestamps arrive as ISO-8601 strings. */

export function formatDateTime(iso: string | null): string {
  if (iso === null) return '-';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '-';
  return d.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatDate(iso: string | null): string {
  if (iso === null) return '-';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '-';
  return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: '2-digit' });
}

/** Compact relative time, e.g. `3h ago`, `just now`, `2d ago`. */
export function relativeTime(iso: string | null): string {
  if (iso === null) return 'never';
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return '-';
  const secs = Math.round((Date.now() - then) / 1000);
  if (secs < 45) return 'just now';
  const mins = Math.round(secs / 60);
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.round(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.round(hours / 24);
  if (days < 30) return `${days}d ago`;
  const months = Math.round(days / 30);
  if (months < 12) return `${months}mo ago`;
  return `${Math.round(months / 12)}y ago`;
}

/**
 * Compact time remaining, e.g. `in 5h`, `in 12m`. The mirror of `relativeTime`, for a
 * deadline rather than a past event — an override's lapse time, most of all.
 */
export function timeUntil(iso: string | null): string {
  if (iso === null) return '-';
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return '-';
  const secs = Math.round((then - Date.now()) / 1000);
  if (secs <= 0) return 'lapsed';
  const mins = Math.round(secs / 60);
  if (mins < 1) return 'in under a minute';
  if (mins < 60) return `in ${mins}m`;
  const hours = Math.round(mins / 60);
  if (hours < 24) return `in ${hours}h`;
  return `in ${Math.round(hours / 24)}d`;
}

/** Title-case a snake/lower token for display, e.g. `crypto_sell` → `Crypto sell`. */
export function humanize(token: string): string {
  const spaced = token.replace(/[_-]+/g, ' ').trim();
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}
